import React, { FC } from 'react';
import { getEtherscanTxLink, getEtherscanAddressLink, getEtherscanContractLink, formatTxHash, formatAddress } from '../utils/etherscan';
import './EtherscanLink.css';

interface EtherscanLinkProps {
  type: 'tx' | 'address' | 'contract';
  hash: string;
  showFullHash?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const EtherscanLink: FC<EtherscanLinkProps> = ({
  type,
  hash,
  showFullHash = false,
  className = '',
  children
}) => {

  const getLink = () => {
    switch (type) {
      case 'tx':
        return getEtherscanTxLink(hash);
      case 'address':
        return getEtherscanAddressLink(hash);
      case 'contract':
        return getEtherscanContractLink(hash);
      default:
        return getEtherscanTxLink(hash);
    }
  };

  const getDisplayText = () => {
    if (children) return children;
    
    switch (type) {
      case 'tx':
        return showFullHash ? hash : formatTxHash(hash);
      case 'address':
      case 'contract':
        return showFullHash ? hash : formatAddress(hash);
      default:
        return hash;
    }
  };

  const getTooltipText = () => {
    switch (type) {
      case 'tx':
        return 'View transaction on Etherscan';
      case 'address':
        return 'View address on Etherscan';
      case 'contract':
        return 'View contract on Etherscan';
      default:
        return 'View on Etherscan';
    }
  };

  return (
    <a
      href={getLink()}
      target="_blank"
      rel="noopener noreferrer"
      className={`etherscan-link ${className}`}
      title={getTooltipText()}
    >
      {getDisplayText()}
      <span className="external-link-icon" aria-hidden="true">↗</span>
    </a>
  );
};

export default EtherscanLink;